export interface SessionState {
	/**
	 * The API session id.
	 */
	id: string;
}

export const initialState: SessionState = {
	id: '',
};
